export enum EOfficeLabel {
  NONE = 'none',
  RESERVED = 'reserved',
}
